(() => {
  const loader =
    document.currentScript ||
    document.querySelector("script[data-localization-drawer-script]");
  const scripts = [
    loader?.dataset.localizationFormScript,
    loader?.dataset.localizationDrawerScript,
  ].filter(Boolean);
  const styleHref = loader?.dataset.localizationDrawerStyle;
  let readyPromise;
  let pendingTrigger = null;

  const isReady = () =>
    customElements.get("localization-drawer") &&
    customElements.get("localization-form");
  const isScriptLoaded = (script) =>
    script.dataset.loaderReady === "true" ||
    script.readyState === "complete" ||
    script.readyState === "loaded" ||
    performance
      .getEntriesByName(script.src, "resource")
      .some((entry) => entry.responseEnd > 0);

  const loadStyle = () => {
    if (!styleHref) return Promise.resolve();
    const existing = Array.from(
      document.querySelectorAll('link[rel="stylesheet"]'),
    ).find((link) => link.href === styleHref);
    if (existing) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const style = document.createElement("link");
      style.rel = "stylesheet";
      style.href = styleHref;
      style.addEventListener("load", resolve, { once: true });
      style.addEventListener("error", reject, { once: true });
      document.head.appendChild(style);
    });
  };

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      const existing = Array.from(document.scripts).find(
        (script) => script.src === src,
      );
      if (existing) {
        if (isScriptLoaded(existing)) {
          existing.dataset.loaderReady = "true";
          resolve();
          return;
        }
        existing.addEventListener("load", () => {
          existing.dataset.loaderReady = "true";
          resolve();
        }, { once: true });
        existing.addEventListener("error", reject, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = src;
      script.async = false;
      script.addEventListener("load", () => {
        script.dataset.loaderReady = "true";
        resolve();
      }, { once: true });
      script.addEventListener("error", reject, { once: true });
      document.head.appendChild(script);
    });

  const load = () => {
    if (isReady()) return Promise.resolve();
    if (readyPromise) return readyPromise;

    readyPromise = loadStyle()
      .then(() => {
        document.querySelector("style[data-localization-deferred]")?.remove();
        return scripts.reduce((promise, src) => promise.then(() => loadScript(src)), Promise.resolve());
      })
      .then(() =>
        Promise.all([
          customElements.whenDefined("localization-drawer"),
          customElements.whenDefined("localization-form"),
        ]),
      )
      .catch((error) => {
        readyPromise = null;
        throw error;
      });

    return readyPromise;
  };

  const getTrigger = (target) => target.closest(".wt-localization-trigger");

  document.addEventListener(
    "pointerdown",
    (event) => {
      if (getTrigger(event.target)) load().catch(() => undefined);
    },
    { capture: true, passive: true },
  );

  document.addEventListener(
    "click",
    (event) => {
      const trigger = getTrigger(event.target);
      if (!trigger || isReady()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (pendingTrigger) return;
      pendingTrigger = trigger;

      load()
        .then(() => {
          pendingTrigger = null;
          if (trigger.isConnected) trigger.click();
        })
        .catch(() => {
          pendingTrigger = null;
        });
    },
    true,
  );
})();
